import { faCheckSquare, faSquare } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FormControl from 'mk2/components/forms/FormControl';
import React from 'react';
import { Field, WrappedFieldInputProps, WrappedFieldProps } from 'redux-form';
import styles from './CheckboxField.mscss';

interface CheckboxInputPublicProps {
    label: string;
    bottomBorder?: boolean;
    disabled?: boolean;
}

type CheckboxInputProps = CheckboxInputPublicProps & {
    input: WrappedFieldInputProps;
};

class CheckboxInput extends React.Component<CheckboxInputProps> {

    public render() {
        const { input, label, disabled } = this.props;
        const { value, ...inputRest } = input;

        return (
            <label htmlFor={input.name} className={styles.CheckboxInput}>
                <FontAwesomeIcon icon={value ? faCheckSquare : faSquare} className={styles.CheckboxInput__icon} />

                <input
                    id={input.name}
                    className={styles.CheckboxInput__input}
                    type="checkbox"
                    {...inputRest}
                    checked={value}
                    disabled={disabled}
                />

                {label}
            </label>
        );
    }
}

interface CheckboxControlPublicProps {
    marginLeft?: boolean;
    isAdminUI?: boolean;
}

type CheckboxControlProps = CheckboxInputPublicProps & CheckboxControlPublicProps & WrappedFieldProps;

const CheckboxControl: React.StatelessComponent<CheckboxControlProps> = ({
    input, label, meta,                           // WrappedFieldProps
    marginLeft, bottomBorder = true,  isAdminUI,  // CheckboxControlPublicProps
    ...chkInputProps                              // CheckboxInputPublicProps
}) => {

    // Never display checkbox form group as active
    const newMeta = {
        ...meta,
        active: false,
    };

    return (
        <FormControl
            marginLeft={marginLeft}
            label={null/* label sa zobrazi vedla checkboxu, nie nad inputom ako je defaultne */}
            input={input}
            meta={newMeta}
            bottomBorder={bottomBorder}
            isAdminUI={isAdminUI}
            disabled={chkInputProps.disabled}
        >
            <CheckboxInput label={label || input.name} input={input} {...chkInputProps} />
        </FormControl>
    );
};

type CheckboxFieldProps = CheckboxInputPublicProps & CheckboxControlPublicProps & {
    // see https://redux-form.com/7.3.0/docs/api/field.md/#props-you-can-pass-to-code-field-code-
    name: string;
};

const CheckboxField: React.StatelessComponent<CheckboxFieldProps> = (props) => (
    <Field {...props} component={CheckboxControl} />
);

export default CheckboxField;
